import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AspCustomerListComponent } from './asp-customer-list.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ApplicationPipesModule } from 'app/main/applicationPipesModule.module';
import { MatFormFieldModule, } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';


const routes: Routes = [
  {
      path: 'customer-list',
      component: AspCustomerListComponent,
  },
  { path: 'order-details/:id', component: AspCustomerListComponent },
];

@NgModule({
  declarations: [AspCustomerListComponent],
  imports:[
   RouterModule.forChild(routes),
       CommonModule,
       BrowserModule,
       FormsModule,
       CommonModule,
       MatIconModule,
       MatExpansionModule,
       MatCheckboxModule,
       BrowserAnimationsModule,
       MatProgressBarModule,
       ApplicationPipesModule,
       ReactiveFormsModule,
       MatFormFieldModule,
       MatInputModule,
       MatSelectModule
  ],
  exports: [AspCustomerListComponent],
})
export class AspCustomerListModule { }
